import { render, staticRenderFns } from "./Orchestra.vue?vue&type=template&id=893e3156&scoped=true&"
import script from "./Orchestra.vue?vue&type=script&lang=js&"
export * from "./Orchestra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893e3156",
  null
  
)

export default component.exports